// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import remAndPhoneConfig from './utils/remConfig'
import axios from 'axios'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import wx from 'weixin-js-sdk'

import { Button, Tabbar, TabbarItem, NavBar, Form, Field, Toast, Loading, Radio, RadioGroup, Icon, Picker, Popup, Dialog } from 'vant'

// vant
Vue.use(Button)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(NavBar)
Vue.use(Form)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Icon)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Dialog)

remAndPhoneConfig()

Vue.config.productionTip = false
Vue.prototype.wx = wx

let startApp = function () {
  const url = '../'
  axios.get(`${url}static/config.json`).then((res) => {
    Vue.prototype.BASE_URL = process.env.NODE_ENV === 'development' ? 'http://192.168.10.200:6123' : `${res.data.host}`

    NProgress.configure({ showSpinner: false }) // NProgress configuration
    // const whiteList = ['/404', '/mlogin'] // 不重定向白名单
    router.beforeEach((to, from, next) => {
      NProgress.start()
      next()
    })

    router.afterEach(() => {
      NProgress.done() // 结束Progress
    })

    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    })
  })
}
startApp()



// WEBPACK FOOTER //
// ./src/main.js